import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  type = 'website',
  article = null 
}) => {
  const location = useLocation();
  const siteUrl = 'https://futuremoney.zlatarenta.com';
  const defaultTitle = 'FUTURE MONEY - Investing in Crypto | EU Registered Crypto Funds';
  const defaultDescription = 'EU registered Asset Management Company for Alternative Investment Funds specializing in cryptocurrency investments. Professional crypto funds for institutional investors.';
  const defaultImage = `${siteUrl}/og-image.png`;

  const seo = {
    title: title ? `${title} | FUTURE MONEY` : defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    url: `${siteUrl}${location.pathname}`,
    keywords: keywords || 'crypto funds, alternative investment funds, cryptocurrency investment, EU regulated, asset management'
  };

  useEffect(() => {
    // Update document title
    document.title = seo.title;

    // Update meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    // Standard meta tags
    updateMeta('description', seo.description);
    updateMeta('keywords', seo.keywords);

    // Open Graph
    updateMeta('og:title', seo.title, true);
    updateMeta('og:description', seo.description, true);
    updateMeta('og:image', seo.image, true);
    updateMeta('og:url', seo.url, true);
    updateMeta('og:type', type, true);

    // Twitter
    updateMeta('twitter:title', seo.title);
    updateMeta('twitter:description', seo.description);
    updateMeta('twitter:image', seo.image);
    updateMeta('twitter:url', seo.url);

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', seo.url);
    }

    // Add article structured data if it's a blog post
    if (article) {
      const existingScript = document.querySelector('script[data-article-schema]');
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-article-schema', 'true');
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": article.title,
        "description": article.excerpt,
        "image": article.image || defaultImage,
        "datePublished": article.publishedAt,
        "dateModified": article.updatedAt || article.publishedAt,
        "author": {
          "@type": "Organization",
          "name": "FUTURE MONEY d.o.o."
        },
        "publisher": {
          "@type": "Organization",
          "name": "FUTURE MONEY d.o.o.",
          "logo": {
            "@type": "ImageObject",
            "url": `${siteUrl}/logo512.png`
          }
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": seo.url
        }
      });
      document.head.appendChild(script);
    }

    // Cleanup
    return () => {
      const articleScript = document.querySelector('script[data-article-schema]');
      if (articleScript) {
        articleScript.remove();
      }
    };
  }, [seo.title, seo.description, seo.image, seo.url, seo.keywords, type, article]);

  return null;
};

export default SEO;

